import { BaseComponent } from '../base-component.js';

export class AgPanel extends BaseComponent {
  protected styles(): string {
    return '';
  }

  protected template(): string {
    return `<div class="ag-panel"><slot></slot></div>`;
  }
}

customElements.define('ag-panel', AgPanel);
